import React from 'react';
import {hydrate} from 'react-dom';
import {Provider} from 'react-redux';
import {App} from '../../shared/App';
import {configureStore} from '../../shared/startup/configureStore';
import AbacusClientUtils, {logExperiment} from '@homeaway/abacus-client-utils';
import {TESTS} from '../../shared/utils/abacus';

/* eslint consistent-return:0 */
export default function hydrateApp() {
    // Grab the state from a global injected into server-generated HTML
    const preloadedState = window.__PRELOADED_STATE__;

    // Create Redux store with initial state
    const store = configureStore({
        initialState: preloadedState
    });

    const {abacus, config} = store.getState();

    AbacusClientUtils.initialize(abacus);

    if (config.context.bodyConfig.exposeSplitHydrate) {
        logExperiment(abacus[TESTS.SPLIT_HYDRATE]);
    }

    hydrate(
        <Provider store={store}>
            <App />
        </Provider>,
        document.querySelector('.app')
    );
}
